/**
 * Converte os parâmetros recebidos por "echartOption.legend.tooltip.formatter" em parâmetros do tipo
 * "echartOption.tooltip.formatter" para poder exibir a tooltip no gráfico ao passar o mouse sobre 
 * a legenda do gráfico de barras simples.
 * @param {array<object>} seriesData Serie de dados plotados no gráfico de barras 
 * @param {array<string>} disabledLegends legendas atualmente desabilitadas no gráfico 
 * @param {Function} defaultFormatter Formatador padrão do gráfico de barras 
 */
export default function legendTooltipFormatter(seriesData = [], disabledLegends = [], defaultFormatter) {
  return function(params) {
    if (disabledLegends.includes(params.name)) return;

    const dataIndex = seriesData.findIndex(({ name }) => name === params.name);
    const value = seriesData[dataIndex].value;
    const numeric = seriesData[dataIndex].numeric;

    const fakeParams = {
      marker: '',
      data: {
        name: params.name,
        value,
        numeric,
      },
      name: params.name,
    };

    return defaultFormatter(fakeParams);
  }
}